// @ts-nocheck
import network from './network'
import networkTS from './networkTS'

/**
 * ListContacts marks every field required in the generated request type, but the endpoint
 * treats an unset field as "no filter". Sending `undefined`/empty values would therefore
 * narrow the result set, so they are stripped before the request goes out.
 */
function compactRequest(request) {
  const compacted = {}
  Object.entries(request).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return
    }
    if (Array.isArray(value) && value.length === 0) {
      return
    }
    if (typeof value === 'string' && value === '') {
      return
    }
    compacted[key] = value
  })
  return compacted
}

export default {
  getAlgoliaKey(accountId) {
    return network.post('web/search/search/generateApiKey', {
      accountId: accountId
    }).then(response => {
      return response.data
    })
  },
  getAlgoliaUnauthorizedKey() {
    return network.post('web/search/search/generateUnauthorizedApiKey').then(response => {
      return response.data
    })
  },
  /**
   * Contact search backed by the MongoDB Atlas read model, replacing the Algolia contact index.
   * Hits are returned with an `objectID` alias so consumers migrated off Algolia keep working.
   */
  listContacts(request, config = {}) {
    return networkTS.searchServiceListContacts(compactRequest(request), config)
      .then(response => {
        const data = response.data
        return {
          ...data,
          hits: (data.hits || []).map(hit => ({ ...hit, objectID: hit.id })),
          facets: data.facets || {
            industries: [],
            ownerNames: [],
            preferredCommunicationChannels: [],
            tags: [],
            types: []
          },
          totalCount: data.totalCount || 0,
          totalPageCount: data.totalPageCount || 0
        }
      })
  },
  loadSettings(accountId) {
    return network.get(`web/search/table/loadSettings?accountId=${accountId}`).then(response => {
      return response.data
    })
  },
  saveSettings(accountId, columns, table) {
    return network.post('web/search/table/saveSettings', {
      accountId: accountId,
      columns: columns,
      table: table
    }).then(response => {
      return response.data
    })
  }
}
